
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

const AdminRoute = () => {
  const { user, loading: authLoading } = useAuth();
  const { userRole, isLoading: roleLoading, isAdmin } = useUserRole();
  const location = useLocation();

  // Show loading while checking authentication and role
  if (authLoading || roleLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-ai-indigo" />
        <span className="ml-2">Verifying admin access...</span>
      </div>
    );
  }

  // If user is not logged in, redirect to admin login
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // If user is logged in but not admin, show unauthorized page
  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-2xl font-bold mb-4">Unauthorized Access</h1>
        <p className="text-gray-600 mb-6">You do not have permission to access the admin area.</p>
        <a href="/" className="text-ai-indigo hover:underline">
          Return to Home Page
        </a>
      </div>
    );
  }

  // If user is admin, render children
  return <Outlet />;
};

export default AdminRoute;
